export default __webpack_public_path__ + "static/greenshield_chat-b2a9cf057f5d5e819e551e1de655c5d4.png";